import React from 'react'
import { Skeleton as Skeleton_ } from 'primereact/skeleton'
import Await from '../_core/components/await'
import { nullPromise } from 'prelude'

export type Structure = {
  width?: string
  height?: string
  className?: string
  style?: React.HTMLAttributes<HTMLDivElement>['style']
  children?: Structure | Structure[] | string[]
}

type SkeletonProps<T> = {
  dependency: Promise<T>
  intermediate?:'undefined' | 'keep' | T
  structure?: Structure | Structure[] | string[]
  children?: (_:T) => React.ReactNode
} & Omit<Structure,'children'>

export const Skeleton = <T,>(props: SkeletonProps<T>) : JSX.Element => {
  return (
    <Await
      dependency={props.dependency}
      intermediate={props.intermediate}
      fallback={
        props.structure
        ? Array.isArray(props.structure)
        ? <div style={{ 'height':props.height,'width':props.width,...props.style }} className={props.className}>
            {props.structure.map((x,i) =>
              typeof x === 'string'
              ? <Skeleton
                  dependency={nullPromise}
                  key={i}
                  className={x}
                ></Skeleton>
              : <Skeleton
                  dependency={nullPromise}
                  key={i}
                  structure={x.children}
                  width={x.width}
                  height={x.height}
                  className={x.className}
                  style={x.style}
                ></Skeleton>
            )}
          </div>
        : <Skeleton
            dependency={nullPromise}
            structure={props.structure.children}
            width={props.structure.width}
            height={props.structure.height}
            className={props.structure.className}
            style={props.structure.style}
          ></Skeleton>
        : <Skeleton_
            width={props.width}
            height={props.height}
            className={props.className}
            pt={{
              'root':{
                'style':props.style,
              }
            }}
          >&nbsp;</Skeleton_>
      }
    >{(value) => props.children ? props.children(value) : undefined}</Await>
  )
}

export default React.memo(Skeleton) as typeof Skeleton
